import * as React from "react";
import Filter from "./Filter.js";
import { ALL_URL } from "../base_url.js";
import { Link } from "react-router-dom";

const Countries = () => {
  const [countries, setCountries] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    setIsLoading(true);
    fetch(ALL_URL)
      .then((res) => res.json())
      .then((data) => {
        setCountries(data);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <main className="main-container">
      <div className="content-container">
        <Filter setCountries={setCountries} />
        <div className="countries-container">
          {isLoading ? (
            <h1>Loading...</h1>
          ) : (
            countries.map((item) => {
              return (
                <Link
                  to={`country/${item.name.common}`}
                  className="country"
                  key={item.name.common}
                >
                  <img src={item.flags.svg} alt={item.name.common} />
                  <div className="country-details">
                    <h3 className="country-title">{item.name.common}</h3>
                    <p>
                      <span>Population:</span>{" "}
                      {item.population.toLocaleString("en-US")}
                    </p>
                    <p>
                      <span>Region:</span> {item.region}
                    </p>
                    <p>
                      <span>Capital:</span> {item.capital}
                    </p>
                  </div>
                </Link>
              );
            })
          )}
        </div>
      </div>
    </main>
  );
};

export default Countries;
